import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import DetailInfo from "Components/UI/DetailInfo/DetailInfo";
import { getNestedProperty } from "Shared/Utils/getNestedProperty";
import { getRoutWithId } from "Shared/Constants/routeIdenicator";
import { ISSUES, UNITS } from "Shared/Constants/routes";
import { dashboardIssuesDetailInfo } from "Shared/Constants/dashboard";
import {
  clearAllInIssues,
  selectCurrentIssue,
  selectCurrentIssueLoading,
} from "Redux/Issue/slice";
import { IIssue } from "Shared/Types/issue";
import { useAppDispatch } from "Redux/store";
import { cropText, splitSnakeCaseString } from "Shared/Utils/shared";

import styles from "./IssuesCalendar.module.scss";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";

type AssignmentDetailProps = {
  closeModal: () => void;
  setIssueId: (id: string | null) => void;
};

const IssuesCalendarDetail: FC<AssignmentDetailProps> = ({
  closeModal,
  setIssueId,
}) => {
  const currentIssue = useSelector(selectCurrentIssue);
  const navigate = useNavigate();
  const loading = useSelector(selectCurrentIssueLoading);
  const dispatch = useAppDispatch();

  const goToDetailPage = () =>
    currentIssue && navigate(getRoutWithId(ISSUES, currentIssue?.id));

  const renderRow = (value: any, key: string) => {
    if (key === "vehicle") {
      return (
        currentIssue?.vehicle && (
          <span
            className={styles.rowCell_blue}
            onClick={(e) => {
              e.stopPropagation();
              navigate(getRoutWithId(UNITS, currentIssue?.vehicle.id));
            }}
          >
            {currentIssue?.vehicle.name || "---"}
          </span>
        )
      );
    }
    if (key === "status") {
      return (
        <p className={styles[`rowCell__status_${value}`]}>
          {splitSnakeCaseString(value)}
        </p>
      );
    }
    if (key === "description") {
      return <p>{cropText({ value })}</p>;
    }
    if (key === "priority") {
      return <p>{splitSnakeCaseString(value)}</p>;
    }
    return currentIssue && getNestedProperty<IIssue>(currentIssue, key);
  };

  useEffect(() => {
    return () => {
      dispatch(clearAllInIssues());
      setIssueId(null);
    };
  }, []);

  if (loading) return <SkeletonLoader height="410px" />;

  return (
    <div>
      {currentIssue && (
        <DetailInfo<IIssue>
          onClickTitle={goToDetailPage}
          title={`Issue ${currentIssue.summary}`}
          renderRow={renderRow}
          data={currentIssue}
          rows={dashboardIssuesDetailInfo}
          onClose={closeModal}
          withoutMaxMinWith
          isStatic
        />
      )}
    </div>
  );
};

export default IssuesCalendarDetail;
